import pathname, { menuType } from '../../../constants/pathname'

export const searchDataSchema = {
  alwaysOpenKeys: ['1'],
  menu: menuType.search,
  sidebars: [
    {
      id: 'section1',
      type: 'nav',
      items: [
        {
          eventKey: '11',
          icon: {
            name: 'book2',
          },
          link: pathname.search.ProposalAllDetail,
          children: 'ค้นหาโครงการทั้งหมด',
        },
        {
          eventKey: '12',
          icon: {
            name: 'profile',
          },
          link: pathname.search.ProjectGranteeBasicInfo,
          children: 'ค้นหาผู้รับทุน/ผู้รับผิดชอบ',
        },
        {
          eventKey: '13',
          icon: {
            name: 'avatar',
          },
          link: pathname.search.ManageExpertAccountsViewOnly,
          children: 'ค้นหาบัญชีผู้ทรงคุณวุฒิ',
        },
        {
          eventKey: '14',
          icon: {
            name: 'profile',
          },
          link: pathname.search.CheckApproval,
          children: 'ตรวจสอบการอนุมัติ',
        },
      ],
    },
  ],
}
